export const ASSIGNMENT_LIST_MIN_HEIGHT = 96;
export const ASSIGNMENT_LIST_TRANSITION_MS = 180;
